// Refund.js
// Garantía y reembolsos, español e inglés. #added 3/11/26 TG
// El texto viene de proposals/refund_page_draft.md (repo timercrossfit), aprobado por Oscar. TG

import React, { useContext, useEffect } from "react";
import { AppContext } from "./ContextVars";

const EMAIL = "muscles@eleven.fit";
const Mail = () => <a href={`mailto:${EMAIL}`} style={{ textDecoration: "underline" }}>{EMAIL}</a>;

const H2 = ({ children }) => <h2 style={{ fontSize: 22, fontWeight: 600, margin: "32px 0 10px" }}>{children}</h2>;
const P = ({ children }) => <p style={{ margin: "0 0 12px" }}>{children}</p>;
const UL = ({ children }) => <ul style={{ margin: "0 0 12px", paddingLeft: 22, listStyle: "disc" }}>{children}</ul>;
const LI = ({ children }) => <li style={{ marginBottom: 8 }}>{children}</li>;

const Spanish = () => (
  <>
    <h1 style={{ fontSize: 34, fontWeight: 600, marginBottom: 8 }}>Garantía y reembolsos</h1>
    <P>Termina tus primeros 3 workouts. Si no te gusta, te devolvemos tu dinero.</P>

    <H2>Cómo funciona</H2>
    <UL>
      <LI>Tienes 15 días desde la fecha de compra para pedirlo.</LI>
      <LI>Para pedirlo, responde al correo de tu compra, o escribe a <Mail /> desde el correo con el que compraste.</LI>
      <LI>Te devolvemos todo lo que pagaste. Nosotros cubrimos la comisión del procesador de pago.</LI>
      <LI>La garantía es para programas y se puede usar una vez por persona.</LI>
      <LI>Tu acceso al programa termina cuando se hace el reembolso.</LI>
    </UL>

    <H2>Cuándo recibes tu dinero</H2>
    <UL>
      <LI>Tarjeta o PayPal: lo devolvemos por el mismo medio. Tu banco decide cuándo aparece en tu cuenta.</LI>
      <LI>Transferencia bancaria: lo devolvemos a mano a la cuenta desde la que pagaste, en un máximo de 10 días hábiles.</LI>
    </UL>

    <P>¿Dudas? Escríbenos a <Mail />.</P>
  </>
);

const English = () => (
  <>
    <h1 style={{ fontSize: 34, fontWeight: 600, marginBottom: 8 }}>Guarantee and refunds</h1>
    <P>Finish your first 3 workouts. If you don't like it, you get your money back.</P>

    <H2>How it works</H2>
    <UL>
      <LI>You have 15 days from the purchase date to ask.</LI>
      <LI>To ask, reply to your purchase email, or write to <Mail /> from the email you bought with.</LI>
      <LI>You get back everything you paid. We cover the payment processor's fee.</LI>
      <LI>The guarantee is for programs and can be used once per person.</LI>
      <LI>Your access to the program ends when the refund is made.</LI>
    </UL>

    <H2>When you get your money</H2>
    <UL>
      <LI>Card or PayPal: refunded the same way you paid. Your bank decides when it shows up in your account.</LI>
      <LI>Bank transfer: refunded by hand to the account you paid from, within 10 business days.</LI>
    </UL>

    <P>Questions? Write to <Mail />.</P>
  </>
);

const Refund = () => {
  const { language } = useContext(AppContext);

  // Igual que Privacy: que abra desde arriba. TG
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main style={{ maxWidth: 760, margin: "0 auto", padding: "110px 20px 40px", textAlign: "left", lineHeight: 1.6 }}>
      {language === "en" ? <English /> : <Spanish />}
    </main>
  );
};

export default Refund;
